module.exports = __webpack_public_path__ + "img/animation_500_kobkewnz (1).5902d84c.gif";